/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FillingStationAreaComponent } from './fillingstationarea.page';
export const routes: Routes = [
    { path: 'fillingstationarea', component: FillingStationAreaComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        FillingStationAreaComponent
    ]
})
export class FillingStationAreaModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/fillingstationarea/fillingstationarea.module.ts